import { useMutation } from '@tanstack/react-query';
import { destroyAggregateInfra } from '../services';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { AxiosResponse } from 'axios';
import {
  AggregateInfraErrorResponse,
  AggregateInfraParams,
  AggregateInfraSuccessResponse,
} from 'SandboxModule/types';
import { useNotification } from 'hooks/useNotification';

export const useDestroyAggregateInfra = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<AggregateInfraSuccessResponse>,
    AxiosResponse<AggregateInfraErrorResponse>,
    AggregateInfraParams
  >({
    mutationFn: async (data) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return destroyAggregateInfra(data, token);
    },
    onSuccess: (response) => {
      if (response.data?.message) {
        showError(`Destroy Aggregate Infra failed! ${response.data?.message}`);
      } else {
        showSuccess('Successfully destroyed Aggregate Infra!');
      }
    },
    onError: (error) => {
      showError(`Destroy Aggregate Infra failed! ${error.data?.message || error}`);
    },
  });

  return {
    destroyAggregateInfra: mutation.mutate,
    isDestroyingAggregateInfra: mutation.isPending,
  };
};
